module.exports = "/_next/static/images/andratop-eed3c309412344450313b3da649456ca.jpg";